import ImagesSlider from 'assets/core/js/module/imagesSlider'

const initPropertiesSliders = function (): void {
  document.querySelectorAll<HTMLElement>('.aquatic__wrapper .slider:not(.slider-initialized)').forEach(function (el) {
    ImagesSlider(el, {
      slidesPerView: 'auto',
      loop: true,
      navigation: {
        nextEl: el.querySelector<HTMLElement>('.slider-button-next'),
        prevEl: el.querySelector<HTMLElement>('.slider-button-prev'),
      },
      pagination: {
        el: el.querySelector<HTMLElement>('.slider-pagination'),
        type: 'custom',
        renderCustom: function (current: number) {
          return `${current}/${el.querySelectorAll('.slide').length}`
        },
      },
      spaceBetween: 0,
    })
  })

  document.querySelectorAll<HTMLElement>('.product__properties-slider .slider:not(.slider-initialized)').forEach(function (el) {
    console.log(el.querySelector<HTMLElement>('.slider-button-next'))

    ImagesSlider(el, {
      loop: true,
      navigation: {
        nextEl: el.querySelector<HTMLElement>('.slider-button-next'),
        prevEl: el.querySelector<HTMLElement>('.slider-button-prev'),
      },
      pagination: {
        el: el.querySelector<HTMLElement>('.slider-pagination'),
        type: 'custom',
        renderCustom: function (current: number, total: number) {
          return `${current}/${total}`
        },
      },
      spaceBetween: 16,
    })
  })
}

export default function (): void {
  initPropertiesSliders()
}
